import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { GenericPBLinkTypeEnum } from "src/app/_models";

@Component({
    selector: 'project-name-renderer',
    templateUrl: './project-name-renderer.component.html',
    standalone: true,
    imports: [CommonModule]
})
export class ProjectNameRendererComponent implements ICellRendererAngularComp {
    public isGroupRow: boolean = false;
    public isEmptyRow: boolean = false;

    public prefix: string = '';
    public entityName: string = '';
    public projectsCount: number = 0;
    public selectedCount: number = 0;

    public projectName: string = '';

    private params: any;

    initilize(params: any): void {
        this.params = params;
        const data = params?.data ?? {};

        this.isGroupRow = !!data.isGroupRow;
        this.isEmptyRow = !!data.isEmptyRow;

        if (this.isGroupRow) {
            this.prefix = data.entityType === GenericPBLinkTypeEnum.Customer ? 'Customer' : 'Cost Centre';
            this.entityName = data.entityName ?? '';
            this.projectsCount = data.projectsCount ?? 0;
            this.selectedCount = data.selectedCount ?? 0;
        } else if (!this.isEmptyRow) {
            this.projectName = data.projectName ?? '';
        }
    }

    agInit(params: any): void {
        this.initilize(params);
    }

    refresh(params: any): boolean {
        this.initilize(params);
        return true;
    }
}
